import React, { useState } from 'react';
import { Grid } from '@material-ui/core';
import { Button, Panel, Typography } from 'components';
// import ConfigForm from './ConfigForm';
import Profile from './form/Profile';
import TimeAndCoordinate from './form/TimeAndCoordinate';
import Approval from './form/Approval';
// import Appearance from './form/Appearance';
import { useAlert, useReduxDispatch, useReduxSelector } from 'store/hooks';
import { saveConfig } from 'store/firebase';
import { fetchEnv } from 'store/app';

const Config = (props) => {
  const app = useReduxSelector((state) => state.app);
  const getEnv = useReduxDispatch(fetchEnv);
  const { alertWaiting, alertSuccess, alertError } = useAlert();
  const [draft, setDraft] = useState('');
  const [showForm, setShowForm] = useState('');

  const renderForm = () => {
    switch (showForm) {
    case 'profile':
      return <Profile
        draft={draft}
        setDraft={setDraft}
        config={app.env} />
    case 'coordinateAndTime':
      return <TimeAndCoordinate
        draft={draft}
        setDraft={setDraft}
        config={app.env}
      />
    case 'approval':
      return <Approval
        draft={draft}
        setDraft={setDraft}
        config={app.env}
      />
    // case 'appearance':
    //   return <Appearance
    //     draft={draft}
    //     setDraft={setDraft}
    //     config={app.env}
    //   />
    default:
      return <TimeAndCoordinate
        draft={draft}
        setDraft={setDraft}
        config={app.env}
      />
      // return <Profile
      //   draft={draft}
      //   setDraft={setDraft}
      //   config={app.env} />
    }
  }

  const handleSaveConfig = () => {
    alertWaiting();
    saveConfig(draft)
      .then(() => {
        alertSuccess();
        getEnv();
      })
      .catch((err) => alertError(err?.messsage || err));
  };

  const handleChangeForm = (form) => {
    setDraft('');
    setShowForm(form)
  }

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Panel>
          <Typography variant='h5'
            style={{
              fontSize: 32,
              fontWeight: 800,
              marginRight: 12
            }}>
            Konfigurasi Aplikasi
          </Typography>
          <Grid container xs={12} spacing={7} style={{ marginTop: 14 }}>
            <Grid item xs={2}>
              {/* <Typography style={{ cursor: 'pointer' }} onClick={() => handleChangeForm('profile')}>Profil</Typography> */}
              <Typography style={{ cursor: 'pointer' }} onClick={() => handleChangeForm('coordinateAndTime')}>Koordinat dan Waktu</Typography>
              {/* <Typography style={{ cursor: 'pointer' }} onClick={() => handleChangeForm('approval')}>Approval</Typography>
              <Typography style={{ cursor: 'pointer' }} onClick={() => handleChangeForm('appearance')}>Penampilan</Typography> */}
            </Grid>
            <Grid item xs={10}>
              {renderForm()}
              <Grid item xs={12} style={{ marginTop: 20, textAlign: 'right' }} >
                <Button onClick={() => handleSaveConfig()} >Simpan</Button>
              </Grid>
            </Grid>
          </Grid>
        </Panel>
      </Grid>
    </Grid>
  )
}

export default Config;
